import React from 'react';
import { Button, Popconfirm } from 'antd';
import { DeleteOutlined, QuestionCircleOutlined } from '@ant-design/icons';

const TeamHeader = ({ index, onRemove }) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>Команда #{index + 1}</span>
        <Popconfirm
            title="Удалить команду?"
            description="Вы уверены, что хотите удалить эту команду?"
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={onRemove}
            okText="Да"
            cancelText="Нет"
            okButtonProps={{ danger: true }}
        >
            <Button type="text" danger icon={<DeleteOutlined />}>
                Удалить
            </Button>
        </Popconfirm>
    </div>
);

export default TeamHeader;